import { useContext, useEffect } from 'react';
import { UNSAFE_LocationContext } from 'react-router-dom';
import { classifyPath, isIndexableKind } from '@/lib/seo/routes';

/**
 * Names the browser tab for pages inside the app. The public pages search
 * engines list (landing, Store, support, privacy, products, providers) have
 * their own search-friendly titles from src/components/Seo.tsx, so this leaves
 * those alone.
 */
export function useDocumentTitle(title: string | null | undefined) {
  const pathname = useContext(UNSAFE_LocationContext)?.location?.pathname ?? (typeof window !== 'undefined' ? window.location.pathname : '/');
  const ownedBySeo = isIndexableKind(classifyPath(pathname).kind);
  useEffect(() => {
    if (!title || ownedBySeo) return;
    const previous = document.title;
    document.title = `${title} · TradePrep`;
    return () => {
      document.title = previous;
    };
  }, [title, ownedBySeo]);
}
